import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const ServicesSlider = ({ services }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className="services-slider px-12">
      <Slider {...settings}>
        {services.map((service, index) => {
          const Icon = service.icon;
          return (
            <div key={index} className="px-4">
              <Card className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 h-full overflow-hidden relative">
                {/* Background Image */}
                {service.backgroundImage && (
                  <div 
                    className="absolute inset-0 bg-cover bg-center opacity-10 group-hover:opacity-15 transition-opacity duration-300"
                    style={{ backgroundImage: `url(${service.backgroundImage})` }}
                  />
                )}
                
                <CardContent className="p-8 text-center relative z-10">
                  <div className="inline-block p-4 bg-[#E5B80B]/10 rounded-lg mb-6 group-hover:bg-[#E5B80B] transition-colors duration-300">
                    <Icon className="h-12 w-12 text-[#E5B80B] group-hover:text-[#1E1E1E] transition-colors duration-300" />
                  </div>
                  <h3 className="sub-heading mb-4">{service.title}</h3>
                  <p className="body-regular mb-6">{service.description}</p>
                  <Link to={service.link}>
                    <Button 
                      className="bg-[#E5B80B] hover:bg-[#c99f09] text-[#1E1E1E] font-semibold transition-all duration-300"
                    >
                      Get Started
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default ServicesSlider;
